import { Component, OnInit, Injector, Inject } from '@angular/core';
import { PartnersBaseComponent } from './../common-theme/index';
import { AgencyService } from '../common-theme/api/agency.service';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})

export class PartnersComponent extends PartnersBaseComponent implements OnInit {
  pageHeight: number;

  constructor(
    injector: Injector,
    agencyService: AgencyService,
    route: ActivatedRoute,
    openModalService: OpenModalService,
    @Inject('SCREEN') private screen: any
  ) {
    super(injector, agencyService, route, openModalService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.screen) {
      this.pageHeight = this.screen.height - 631;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.ts